import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLenis } from "../components/SmoothScroll";

export default function SiteMap() {
  const lenisRef = useLenis();

  useEffect(() => {
    lenisRef?.current?.scrollTo(0);
  }, []);

  return (
    <div className="max-w-5xl mx-auto md:py-40 py-20 px-6 text-[#f5f5f5]">
      <h1 className="font-heading lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal py-4 capitalize">
        Sitemap
      </h1>

      <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 mt-4">
        <MainItem title="Home" link="/" />

        <MainGroup title="About" link="/about-us">
          <SubItem
            title="History"
            link="/about-us#history"
          />
          <SubItem
            title="Leadership"
            link="/about-us#leadership"
          />
          <SubItem
            title="Featured Services"
            link="/about-us#featured-services"
          />
          <SubItem
            title="Accreditations"
            link="about-us#accreditations"
          />
          <SubItem
            title="Chief Medical Officer"
            link="/chief-medical-officer"
          />
          
        </MainGroup>

        <MainGroup title="Services" link="/diagnostic-imaging-services">
          <SubItem title="MRI" link="/open-mri-and-imaging" />
          <SubItem title="PET-CT" link="/pet-scan-imaging" />
          <SubItem title="Prostate Imaging" link="/prostate-on-mri" />
          <SubItem title="Cardiac & Vascular Imaging" link="/cardiac-imaging" />
          <SubItem title="Women’s Imaging" link="/womens-imaging-center" />
          <SubItem
            title="Personal Injury / Workers' Compensation"
            link="/personal-injury"
          />
        </MainGroup>

        <MainItem title="Patients" link="/patient-portal" />
        <MainItem title="Providers" link="/healthcare-providers" />

        <MainGroup title="Resources" link="/resources">
          <SubItem title="Insurance & Billing" link="/resources" />
          <SubItem title="Medical Records" link="/resources#medical-records" />
          <SubItem
            title="Advanced Technology & AI"
            link="/advanced-ai-medical-imaging"
          />
          <SubItem title="Frequently asked question" link="/faqs" />
        </MainGroup>

        <ExternalItem
          title="Patient Login"
          link="https://citrusfl.abbadox.com/patientportal/login"
        />
        <ExternalItem
          title="Provider Login"
          link="https://www.abbadoxcareflow.com"
        />
        <ExternalItem
          title="Legal Login"
          link="https://prod.myclearpath.com/login"
        />

        <MainItem title="Contact" link="/contact-us" />
      </ul>
    </div>
  );
}

/* ================= COMPONENTS ================= */

function MainItem({ title, link }) {
  return (
    <li className="flex items-center gap-3 text-[24px] text-[#cccccc] font-medium">
      <Arrow />
      <Link to={link} className="hover:underline">
        {title}
      </Link>
    </li>
  );
}

function MainGroup({ title, link, children }) {
  return (
    <li>
      <div className="flex items-center gap-3 text-[24px] text-[#cccccc] font-medium">
        <Arrow />
        <Link to={link} className="hover:underline">
          {title}
        </Link>
      </div>
      <ul className="ml-10 mt-3 space-y-3">{children}</ul>
    </li>
  );
}

function SubItem({ title, link }) {
  return (
    <li className="flex items-center gap-3 text-[24px] text-[#cccccc] font-medium">
      <SubArrow />
      <Link to={link} className="hover:underline">
        {title}
      </Link>
    </li>
  );
}

function ExternalItem({ title, link }) {
  return (
    <li className="flex items-center gap-3 text-[24px] text-[#cccccc] font-medium">
      <Arrow />
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        {title}
      </a>
    </li>
  );
}

/* ================= ARROWS ================= */

function Arrow() {
  return (
    <span className="inline-block w-0 h-0 border-t-[12px] border-b-[12px] border-l-[14px] border-transparent border-l-[#d78558]" />
  );
}

function SubArrow() {
  return (
    <span className="inline-block w-0 h-0 border-t-[7px] border-b-[7px] border-l-[9px] border-transparent border-l-white" />
  );
}
